import React, { forwardRef } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { ReactComponent as CalendarIcon } from '../assets/calendar.svg'
import 'react-datepicker/dist/react-datepicker.css'

const CalendarPortalStyle = createGlobalStyle`
  #calendar-portal,
  .react-datepicker-popper {
    z-index: 200;
  }
`

interface CalendarProps {
  label: string
  selectedDate: Date | null
  onChange: (date: Date | null) => void
  withHour?: boolean
  startMonth?: Date
}

const Calendar: React.FC<CalendarProps> = ({
  label,
  selectedDate,
  onChange,
  withHour = false,
  startMonth = undefined,
}) => {
  return (
    <div>
      <CalendarPortalStyle />
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        showTimeSelect={withHour}
        timeFormat="HH:mm"
        locale="utc"
        timeIntervals={30}
        timeCaption="Time"
        dateFormat={withHour ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd'}
        customInput={<CustomDateButton label={label} />}
        openToDate={startMonth}
        portalId="calendar-portal"
        popperProps={{ strategy: 'fixed' }}
      />
    </div>
  )
}

interface CustomDateButtonProps {
  value?: string
  onClick?: () => void
  label: string
}

// ✅ Properly forward `value` and `onClick`
const CustomDateButton = forwardRef<HTMLButtonElement, CustomDateButtonProps>(({ value, onClick, label }, ref) => {
  return (
    <Button ref={ref} onClick={onClick} type="button">
      {value ? moment(value, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm') : label} 
      <CalendarIcon />
    </Button>
  )
})

const Button = styled.button.attrs({ type: 'button' })`
  border-radius: 10px;
  background: transparent;
  border: 2px solid #5f5d62;
  color: #fff;
  font-family: 'DMSans';
  font-size: 13px;
  padding: 0 10px;
  height: 34px;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;

  &:hover {
    border-color: #0070f3;
  }
`

export default Calendar